import * as React from 'react';

interface Props {
    initiallyEnabled: boolean;
    onChange?: (isEnabled: boolean) => void;
    onChangePromise?: (newIsEnabled: boolean, accept: () => void, reject: () => void) => void;
    isReadonly: boolean;
    className: string;
    label: string;
}

interface State {
    enabled: boolean;
}

export default class ToggleField extends React.PureComponent<Props, State> {
    static defaultProps = {
        initiallyEnabled: false,
        className: '',
        isReadonly: false,
    };

    constructor(props: Props) {
        super(props);

        this.state = {
            enabled: props.initiallyEnabled,
        };
    }

    componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
        const { initiallyEnabled } = this.props;

        if (initiallyEnabled !== prevProps.initiallyEnabled) {
            this.setState({
                enabled: initiallyEnabled,
            });
        }
    }

    handleClick = (evt: React.MouseEvent): void => {
        const { onChangePromise, isReadonly } = this.props;
        const { enabled } = this.state;

        if (!isReadonly) {
            evt.stopPropagation();
            evt.nativeEvent.stopImmediatePropagation();

            if (onChangePromise) {
                onChangePromise(
                    !enabled,
                    () => {
                        this.setEnabled();
                    },
                    () => {},
                );
            } else {
                this.setEnabled();
            }
        }
    };

    setEnabled = (): void => {
        const { onChange } = this.props;

        this.setState((prevState: State) => {
            if (onChange) {
                onChange(!prevState.enabled);
            }

            return {
                enabled: !prevState.enabled,
            };
        });
    };

    render() {
        const { enabled } = this.state;
        const { isReadonly, className, label } = this.props;

        const toggleConClasses: Array<string> = ['ddbc-toggle-field', className];
        if (enabled) {
            toggleConClasses.push('ddbc-toggle-field--is-enabled');
        } else {
            toggleConClasses.push('ddbc-toggle-field--is-disabled');
        }
        if (!isReadonly) {
            toggleConClasses.push('ddbc-toggle-field--is-interactive');
        }

        return (
            <div
                role="checkbox"
                tabIndex={0}
                className={toggleConClasses.join(' ')}
                onClick={this.handleClick}
                aria-checked={enabled}
                aria-label={label}
            >
                <div className="ddbc-toggle-field__nub" />
            </div>
        );
    }
}
